module.exports = __webpack_public_path__ + "static/media/logo.af537a36.png";